export const YCLIENTS_MARKETPLACE_URL = 'https://yclients.com/e/mp_50568_okidoki_2/'

/** Текст для карточки приложения в маркетплейсе YCLIENTS → «Об интеграции». */
export const YCLIENTS_MARKETPLACE_ABOUT =
    'ОкиДоки — электронное подписание договоров. Из карточки клиента в окне записи ' +
    'YCLIENTS можно выбрать шаблон, создать договор и сразу увидеть статус. ' +
    'ФИО, телефон и дата рождения подставляются из окна записи. Email и дополнительные ' +
    'поля карточки попадут в договор, если сохранён User Token из кабинета разработчика ' +
    '(приложение ОкиДоки → «Доступ к API») и при «Подключить» выданы права на клиентскую базу. ' +
    'Названия полей шаблона должны совпадать с названиями полей в YCLIENTS.'

/** Инструкция для модерации: «Инструкция для подключения интеграции». */
export const YCLIENTS_MARKETPLACE_CONNECT_GUIDE = [
    'Откройте маркетплейс YCLIENTS и подключите приложение ОкиДоки. На экране «Доступ к разделам» нажмите «Продолжить»: в списке должна быть клиентская база.',
    'Во вкладке «Настройки» вставьте API-ключ из кабинета ОкиДоки: Профиль → Интеграции → YCLIENTS.',
    'Чтобы подставлялись email и доп. поля карточки, вставьте User Token из кабинета разработчика: приложение ОкиДоки → «Доступ к API». Это не Partner Token из «Настройки аккаунта».',
    'Если права приложению выдали уже после «Подключить», отключите ОкиДоки в филиале и подключите снова.',
    'Сохраните. Во вкладке клиента в окне записи 2.0 появится ОкиДоки — выберите шаблон и создайте договор.',
    'Тестовый филиал для проверки: salon_id 2201967. Iframe вкладки: https://api.doki.online/yclients-widget/',
].join('\n')
